import type { AppDispatch } from "src/store/store";
import { useDispatch } from "react-redux";
import {
  Card,
  CardContentWithLabels,
  CardHeader,
  P,
  CardContent,
  MoneyStockModal,
} from "src/components";
import cn from "classnames";
import { getDateLabel, renderTestId } from "src/utils/HelperFunctions";
import { useCard } from "src/store/slices/cardsSlice";
import { setModalOpen, useModal } from "src/store/slices/modalSlice";
import { getCardOrEmptyState } from "src/utils/transformers/cardDataTransformer";
import { cardConfig } from "src/utils/constants/CardConfig";
import { Fragment } from "react";
import { getExchangeRates } from "src/store/slices/exchangeRatesSlice";

const CARD_ID = "21e504e6-eb5f-4228-a671-63bac94cbaa4";

interface Props extends React.HTMLAttributes<HTMLDivElement> {
  span?: 1 | 2 | 3 | 4 | 6;
  cardVariant?: "default" | "secondary" | "highlighted";
}

const MoneyStockCard: React.FC<Props> = ({
  span = 2,
  cardVariant = "highlighted",
}) => {
  const dispatch = useDispatch<AppDispatch>();
  const isOpen = useModal(cardConfig[CARD_ID].modalId) ?? false;
  const { isEmpty, card, isNotLoaded } = getCardOrEmptyState(
    CARD_ID,
    useCard(CARD_ID)
  );

  const openModal = () => {
    !isEmpty && dispatch(setModalOpen(cardConfig[CARD_ID].modalId));
    !isEmpty && dispatch(getExchangeRates());
  };

  return (
    <Fragment>
      <Card
        variant={cardVariant}
        {...renderTestId(cardConfig[CARD_ID].testId)}
        onClick={openModal}
        header={
          <CardHeader
            title={cardConfig[CARD_ID].title}
            subtitle={
              <div className={cn("flex", "items-center", "gap-0.5")}>
                <P className={cn("text-xs", "font-400", "opacity-70")}>
                  Frissítve
                </P>
                <P className={cn("text-xs", "font-500", "opacity-80")}>
                  {getDateLabel(card?.updatedAt)}
                </P>
              </div>
            }
            info={cardConfig[CARD_ID].infoText}
            icon={cardConfig[CARD_ID].icon}
          />
        }
        span={span}
        content={
          <CardContent
            isLocked
            isEmpty={isEmpty}
            isNotLoaded={isNotLoaded}
            className="h-full"
          >
            <CardContentWithLabels
              data={card?.data}
              span={span}
              isLocked
              isEmpty={isEmpty}
              className="px-1"
            />
          </CardContent>
        }
        isEmpty={isEmpty}
      />
      {isOpen && <MoneyStockModal />}
    </Fragment>
  );
};

export default MoneyStockCard;
